module.exports = __webpack_public_path__ + "img/logo_quick_pay_2022.263f5f6c.png";